<template>
    <Head :title="pageTitle"/>
    <student-time-tracker/>
    <FlashMessages/>
    <HoneybadgerErrorTracking/>

    <div class="flex min-h-screen flex-col">
        <main class="flex flex-grow bg-white">
            <div
                :class="
                    'mx-auto flex  flex-grow flex-col' +
                    ' ' +
                    ('bg-' + contentBgColor)
                "
            >
                <div class="bg-gray-825 text-white">
                    <div class="mx-auto h-16 w-auto px-4">
                        <div class="flex h-full items-center justify-between">
                            <div class="flex-none">
                                <img
                                    class="h-10"
                                    src="/assets/art/logos/emtprep_logo_ondark@2x.png"
                                />
                            </div>
                            <div
                                class="mx-auto hidden flex-grow px-4 text-center md:block"
                            >
                                <text-clamp
                                    autoResize
                                    :max-lines="1"
                                    :text="pageTitle"
                                ></text-clamp>
                            </div>
                            <div
                                v-if="!hideExitButton"
                                @click="exitPage"
                                class="my-2 whitespace-nowrap rounded border border-white px-2 py-2 text-[16px] hover:cursor-pointer hover:bg-white/10"
                            >
                                <span v-html="exitButtonText"></span>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- main content -->
                <div
                    v-if="$slots.page_header"
                    :class="'w-full' + ' bg-' + headerBgColor"
                >
                    <div
                        class="mx-auto w-auto max-w-[1440px] px-4 py-4 lg:px-10"
                    >
                        <slot name="page_header"/>
                    </div>
                </div>
                <div class="h-full w-full">
                    <div
                        class="mx-auto flex h-full w-auto max-w-[1440px] px-4 py-4 lg:px-10"
                    >
                        <slot name="content"></slot>
                    </div>
                </div>
            </div>
        </main>
    </div>
</template>

<script>
import FlashMessages from "@/Components/FlashMessages";
import StudentTimeTracker from "@/Components/StudentTimeTracker.vue";
import HoneybadgerErrorTracking from "@/Components/HoneybadgerErrorTracking.vue";

export default {
    name: "StudentBackendFocusLayout",
    emits: ["exit-page-clicked"],
    components: {
        HoneybadgerErrorTracking,
        StudentTimeTracker,
        FlashMessages,
    },
    props: {
        hideHeader: {
            type: Boolean,
            default: false,
        },
        pageTitle: {
            type: String,
            default: "",
        },
        headerBgColor: {
            type: String,
            default: "gray-100",
        },
        contentBgColor: {
            type: String,
            default: "white",
        },
        hideExitButton: {
            type: Boolean,
            default: false,
        },
        exitButtonText: {
            type: String,
            default: "",
        },
    },

    methods: {
        exitPage: function () {
            this.$emit("exit-page-clicked");
        },
    },
};
</script>
